import SDIcon from '../SDIcon'
import type { SDIconProps } from '../SDIcon'

const IconShieldPlus = ({ size = 16, color = 'currentColor', ...props }: SDIconProps) => (
  <SDIcon viewBox='0 0 24 24' size={size} color={color} aria-hidden='true' {...props}>
    <g fill='none' stroke='currentColor' strokeWidth='1.9' strokeLinecap='round' strokeLinejoin='round'>
      <path d='M12 3l7 3v5c0 4.5-3 8.2-7 10-4-1.8-7-5.5-7-10V6z' />
      <path d='M12 9v6M9 12h6' />
    </g>
  </SDIcon>
)

export default IconShieldPlus
